import React from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { sliceWords } from "../../../../utils/functions";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";

export default function ListDataTermsAndCondition({
  list = [],
  editData,
  deleteData,
  loading,
  titles = [],
  component,
}) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>  checkAccessFn(dashboardData, module, name);

  const { NoDataFound, Pagination, PaginationIndex, Search, currentList } =
    useSearchPagination(list?.data ? list?.data : []);

  return (
    <div className="pt-2 uppercase">
      <div className="flex md:flex-row flex-col  justify-between items-end">
        <Search searchKey={["particulars", "remarks"]} />
        <p className="text-sm w-full text-right font-medium mb-1 lg:hidden block">{`Slide / scroll to right >`}</p>
      </div>
      <div
        className={`grid justify-items-center grid-cols-table-4 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {list?.isLoading && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-4">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        <NoDataFound />

        {currentList.map((list, index) => (
          <React.Fragment key={index}>
            <PaginationIndex index={index} />
            <p>{list.particulars}</p>
            <p>
              {component === "quotation-terms"
                ? sliceWords(list.remark)
                : sliceWords(list.remarks)}
            </p>

            <div className="flex gap-3 min-w-fit ">
              {checkAccess(
                "Terms And Condition",
                "terms-and-conditions-edit"
              ) ? (
                <button
                  className="p-1 px-2 rounded-md ring-1 ring-slate-600"
                  onClick={() => editData(list.id, list)}
                  disabled={loading.edit}
                >
                  {loading.edit && loading.loadingId === list.id ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <CiEdit size={"1.4rem"} />
                  )}
                </button>
              ) : (
                <p className="p-1 px-2 rounded-md ring-1 ring-slate-300">--</p>
              )}

              {checkAccess(
                "Terms And Condition",
                "terms-and-conditions-delete"
              ) ? (
                <button
                  className="p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                  onClick={() =>
                    deleteData((oldState) => ({ open: true, id: list.id }))
                  }
                  disabled={loading.delete}
                >
                  {loading.delete && loading.loadingId === list.id ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <MdDeleteOutline size={"1.4rem"} />
                  )}
                </button>
              ) : (
                <p className="p-1 px-2 rounded-md ring-1 ring-slate-300">--</p>
              )}
            </div>
            <hr
              className={`border-[1.5px] border-slate-100  w-full col-span-4 `}
            />
          </React.Fragment>
        ))}
      </div>
      <Pagination />
    </div>
  );
}